import angular from 'angular';
import { accordionComponent } from './accordionComponent';
import { accordionPaneComponent } from './pane/accordionPaneComponent';

angular
	.module('sh.accordion', [])
	.component('shAccordion', accordionComponent())
	.component('shAccordionPane', accordionPaneComponent());
